import Icon from "../../fragments/icon/Icon";
import TicketsPanel from "./TicketsPanel";

export default function Tickets({ tickets }) {
  // if (!item) return null;

  return (
    <div className={"Tickets"}>
      {tickets.map((ticket, index) => {
        return <TicketsPanel ticket={ticket} key={index} />;
      })}
    </div>
  );
}
